import Avatar from '@components/dataDisplay/Avatar';
import React from 'react';
import styled from 'styled-components';
import { ISelectItem } from '.';
import { SelectTrigger, ArrowIcon, SelectValueWrap, SpinnerIcon } from './selectorStyle';

const Div = styled.div``;

interface SelectBtnProps {
  onClick: any;
  open: boolean;
  defaultValue?: string;
  disabled?: boolean;
  loading?: boolean;
  size: 'xl' | 'md' | 'sm';
  item: ISelectItem;
}

function SelectBtn({
  onClick,
  open,
  disabled,
  loading,
  defaultValue,
  size,
  item,
}: SelectBtnProps) {
  return (
    <SelectTrigger disabled={disabled || loading} onClick={onClick} size={size}>
      <SelectValueWrap>
        {item && item.thumbnail && (
          <Avatar photoURL={item.thumbnail} size="20px" />
        )}
        {item && item.value ? item.value : defaultValue}
      </SelectValueWrap>
      {loading ? <SpinnerIcon /> : <ArrowIcon isSelectOpen={open} />}
    </SelectTrigger>
  );
}

export default React.memo(SelectBtn);
